import type { SeoMeta } from '$lib/seo';

export const load = (): { seo: SeoMeta } => ({
	seo: {
		title: 'Trust & compliance',
		description:
			'How Ekavi Care handles security, privacy, and compliance: HIPAA Security Rule annual verification, AI-specific BAA, audit log, HTI-1 transparency, Section 1557, sub-processors, incident response, and offboarding.',
		path: '/trust/',
		pageType: 'WebPage'
	}
});
